export default __webpack_public_path__ + "static/media/fancraft.e227b6f1.jpg";